<template>
  <teleport to="#modal">
    <div
      v-if="modal.getOpen && modal.id == id"
      aria-hidden="true"
      class="overflow-y-auto overflow-x-hidden flex backdrop-blur-sm bg-primary bg-opacity-30 items-center justify-center fixed top-0 right-0 left-0 z-50 w-full md:inset-0 h-modal md:h-full"
    >
      <div class="relative w-full h-full md:h-auto" :class="[widthMax]">
        <div class="relative bg-white rounded-lg shadow dark:bg-gray-700">
          <div class="flex justify-between items-start px-4 py-2 rounded-t">
            <button
              type="button"
              @click="modal.closeModal"
              class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
              data-modal-toggle="defaultModal"
            >
              <svg
                aria-hidden="true"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clip-rule="evenodd"
                ></path>
              </svg>
              <span class="sr-only">Close modal</span>
            </button>
          </div>
          <div class="flex flex-col justify-center items-center">
            <img src="../assets/trash.gif" />

            <h1 class="mt-3 text-2xl font-bold">Delete Data</h1>
            <h3 class="mt-1 font-normal text-gray-500">
              Are you sure you want to delete this data ?
            </h3>
          </div>
          <div class="flex justify-end items-center p-6 space-x-2 rounded-b">
            <ButtonComponent
              vClass="bg-darkGreen hover:bg-greenPrimary"
              @click="$emit('onDeleteData')"
            >
              YES
            </ButtonComponent>
            <ButtonComponent @click="modal.closeModal" vClass="btn-darkGray">
              NO
            </ButtonComponent>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import ButtonComponent from "./ButtonComponent.vue";
export default {
  emits: ["onDeleteData"],
  props: {
    widthMax: {
      type: String,
      default: "max-w-sm",
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  inheritAttrs: false,
  components: {
    ButtonComponent,
  },
  setup() {
    const { useModalStore } = require("@/store");

    const modal = useModalStore();

    return {
      modal,
    };
  },
};
</script>
